import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { counterpartyAccountsApi } from '@/features/counterpartyAccounts/counterpartyAccountsApi';

import { CounterpartyAccountByIdentityId } from './types';

interface AuthState {
  account?: CounterpartyAccountByIdentityId;
}

const initialState: AuthState = {
  account: undefined,
};

const counterpartyAccountsSlice = createSlice({
  name: 'counterpartyAccounts',
  initialState,
  reducers: {
    _: () => {},
  },
  extraReducers: builder =>
    builder.addMatcher(
      counterpartyAccountsApi.endpoints?.getCounterpartyAccountByIdentityId
        .matchFulfilled,
      (state, action: PayloadAction<CounterpartyAccountByIdentityId>) => {
        state.account = action.payload;
      },
    ),
  selectors: {
    selectCurrentAccount: state => state.account,
  },
});

export default counterpartyAccountsSlice;

export const useCounterpartyAccountByIdentityId = () =>
  useSelector(counterpartyAccountsSlice.selectors.selectCurrentAccount);
